export default __webpack_public_path__ + "static/media/sample_new_shop.66dafa65.png";